// NotificationBell — shows unread notification count badge.
// Subscribes to notifications.unread via the fetch plugin.
// Navigates to /inbox on click.
//
// v3.14 rules: flat access, el.router for navigation, design tokens only.

export const NotificationBell = {
  extends: 'Button',
  position: 'relative',
  padding: 'Z1',
  round: '50%',
  cursor: 'pointer',
  theme: 'tertiary',
  title: 'Notifications',

  // Declarative subscription — fetch plugin routes through SDK.
  // Result lands at ~/notificationsUnread on the root state.
  // migrated 2026-04-27 to entity route workspaceProject.realtime.notifications.
  fetch: {
    from: 'workspaceProject.realtime.notifications',
    method: 'subscribe',
    params: (el, s) => ({ userEmail: s.root?.currentUserEmail }),
    as: '~/notificationsUnread'
  },

  Icon: {
    name: 'bell',
    boxSize: 'A A'
  },

  UnreadBadge: {
    // Hide badge when no unread notifications
    hide: (el, s) => !s.root?.notificationsUnread || s.root.notificationsUnread <= 0,
    position: 'absolute',
    top: '0',
    right: '0',
    minWidth: 'Y',
    height: 'Y',
    round: '50%',
    background: 'red',
    align: 'center center',
    padding: '0 V',
    pointerEvents: 'none',
    fontSize: 'Y2',
    fontWeight: '600',
    color: 'white',
    text: (el, s) => {
      const count = s.root?.notificationsUnread || 0
      return count > 99 ? '99+' : String(count)
    }
  },

  onClick: (e, el) => {
    e.preventDefault()
    el.router('/inbox', el.getRoot())
  }
}
